import { render, staticRenderFns } from "./PcLogo.vue?vue&type=template&id=a351dcd6&scoped=true&"
import script from "./PcLogo.vue?vue&type=script&lang=js&"
export * from "./PcLogo.vue?vue&type=script&lang=js&"
import style0 from "./PcLogo.vue?vue&type=style&index=0&id=a351dcd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a351dcd6",
  null
  
)

export default component.exports